import template from './index.html'
import controller from './controller'

export const vsName = 'machinesContractMain'
export const vsNgType = 'directive'

MachineContractsMainDirective.$inject = []
export function MachineContractsMainDirective() {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {},
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true
  }
}
